import { AlertProps as MuiAlertProps } from '@mui/material';
import { MuiAlert } from '../../../../../modules/material';

export enum AlertStrokes {
  standard = 'standard',
}

export interface AlertProps extends MuiAlertProps {
  stroke?: keyof typeof AlertStrokes;
}

export default function Alert(props: AlertProps) {
  const { variant = 'standard', children, ...alertProps } = props;

  return (
    <MuiAlert variant={variant} {...alertProps}>
      {children}
    </MuiAlert>
  );
}
